export const ErrHPClaimed = "this heat pump has already been claimed"
export const ErrHPUnclaimed = "this heat pump has not been claimed"
export const ErrHeatPumpDoesNotExist = "this heat pump does not exist"
export const ErrInviteToSelf = "you cannot invite yourself"
export const ErrUserWithoutAcc = "user exists, but does not have an account"
export const ErrCanNotRemoveOwner = "heat pump owner can't remove heat pump while other groups have access"
export const ErrCanNotRemoveLastAdmin = "last admin can't be removed from a group with other users"
